const FULL_WIDTH_SPACE = '\u3000';

export const getMessageForInvalidOrders = (orders: { orderId: number, realClientName?: string, positionName?: string }[]): string => {
  // eslint-disable-next-line no-irregular-whitespace
  // 「求人ID : 株式会社●●●●　求人タイトル」
  return orders.map(order => `\n${order.orderId} : ${order.realClientName}${FULL_WIDTH_SPACE}${order.positionName}`)
              .join('');
};